import { stats } from '@/mocks/about';

export default function StatsSection() {
  return (
    <section className="w-full py-14 md:py-16 bg-primary-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-extrabold text-background-50 mb-1 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-primary-100 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}